import React from "react"

import { Switch } from "@mui/material"
import { SwitchProps } from "@mui/material/Switch/Switch"
import { styled } from "@mui/material/styles"

interface IProps extends SwitchProps {
  checkedText?: string,
  uncheckedText?: string,
  width?: string
}

const checkedTextDefault = "On"
const uncheckedTextDefault = "Off"
const widthDefault = "60px"

const TheSwitch = ({
                     checkedText = checkedTextDefault,
                     uncheckedText = uncheckedTextDefault,
                     width = widthDefault,
                     ...props
                   }: IProps) =>

  <Switch
    {...props}
    disableRipple />


export const LabeledSwitch = styled(TheSwitch)(({
                                                  width = widthDefault,
                                                  uncheckedText = uncheckedTextDefault,
                                                  checkedText = checkedTextDefault
                                                }) => ({
    height: "26px",
    padding: 0,
    borderRadius: "36px",
    width,

    "& [class*=MuiSwitch-switchBase]": {
      color: "#818181",
      padding: 0,
      height: "26px",
      left: "4px",
      backgroundColor: "unset",
      transition: "left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",

      "& .MuiSwitch-input": {
        left: 0,
        width,
        margin: 0
      },

      "&.Mui-checked": {
        width: "22px",
        backgroundColor: "unset",
        right: `calc(74px - ${width})`,
        transform: `translateX(calc(${width} - 30px))`,

        "& .MuiSwitch-input": {
          left: `calc(26px - ${width})`,
          position: "absolute"
        },

        "& + .MuiSwitch-track": {
          backgroundColor: "#B79DB3",
          opacity: 1,
          "&:before": {
            content: `'${checkedText}'`,
            left: "10px"
          }
        }
      },

      "&:not(.Mui-checked)": {
        "& + .MuiSwitch-track": {
          "&:after": {
            content: `'${uncheckedText}'`,
            left: "28px"
          }
        }
      }
    },

    "& .MuiSwitch-track": {
      backgroundColor: "#83667E",
      opacity: 1,
      color: "#fff",
      fontWeight: 600,
      fontSize: "10px",

      "&:after, &:before": {
        position: "absolute",
        lineHeight: "26px",
        width: "calc(100% - 38px)",
        textAlign: "center"
      }
    },

    "& [class*=MuiSwitch-thumb]": {
      width: "22px",
      height: "22px",
      color: "#fff",
      margin: 0
    }

  })
)

